<template>
    <div class="pages__titel">
        <h2>{{ $props.titel }}</h2>
        <div class="pages__titel__actions" v-if="button">
            <div class="pages__titel__actions__search">
                <div v-if="search" class="button" @click="zoekStop"><i class="fa-solid fa-xmark"></i></div>
                <div v-else class="button" @click="zoekItem"><i class="fa-solid fa-magnifying-glass"></i></div>
                <input type="text" :placeholder="$props.zoek" v-model="zoekbalk" @keyup.enter="zoekItem">
            </div>
            <p v-if="addItems !== false" @click="$emit('click_new')" :class="buttonClass"><i class="fa-solid fa-plus"></i></p>
        </div>
    </div>
</template>
<script>
export default {
    props:['titel', 'zoek', 'button', 'addItems'],
    inject:["status", "notification"],
    data(){
        return{
            zoekbalk: "",
            search: false,
            buttonClass: "button pages__titel__actions__button"
        }
    },
    methods:{
        zoekStop(){
            this.search = false
            this.zoekbalk = "";
            this.$emit("zoek_stop"), this.zoekbalk;
        }
    },
    watch:{
        zoekbalk(x){
            if(x.trim() == ""){
                this.search = false;
                this.$emit("zoek_stop"), this.zoekbalk;
            } else{
                this.search = true
                this.$emit("zoek_item", this.zoekbalk);
            }
        },
        notification: {
        handler(x){
            console.log(x);
            if(x.status){
                this.buttonClass = "button pages__titel__actions__button add__up";
            } else{
                this.buttonClass = "button pages__titel__actions__button";
            }
        },
        deep: true
        },
    }
}
</script>